<template>
  <div class="navigator">
    <v-row align="center" dense>
      <v-col v-show="date !== today()" class="py-0">
        <v-fab-transition>
          <vs-button icon="home" small type="secondary" @click="homeClicked" />
        </v-fab-transition>
      </v-col>
      <v-col class="py-0">
        <vs-button icon="keyboard_arrow_left" small type="secondary" @click="leftArrowClicked" />
      </v-col>
      <v-col class="py-0">
        <vs-button icon="keyboard_arrow_right" small type="secondary" @click="rightArrowClicked" />
      </v-col>
      <v-col class="py-0">
        <v-menu
          v-model="menu"
          :close-on-click="false"
          :close-on-content-click="false"
          :nudge-bottom="8"
          offset-y
        >
          <template #activator="{ on }">
            <vs-button icon="event" small type="secondary" @click="menu = !menu" v-on="on" />
          </template>
          <v-date-picker :value="date" @change="dateSelected" />
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import moment from 'moment'

interface Range {
  start: moment.Moment | Date | string
  end: moment.Moment | Date | string
}

const props = defineProps<{
  range: Range
}>()

const emit = defineEmits<{
  (e: 'rangechanged', range: Range): void
}>()

const menu = ref(false)

const numHoursShown = computed(() => {
  return moment(props.range.end).diff(props.range.start, 'hours')
})

const date = computed(() => {
  return moment(props.range.start)
    .add(numHoursShown.value / 2, 'hours')
    .format('YYYY-MM-DD')
})

const today = () => moment().format('YYYY-MM-DD')

const homeClicked = () => {
  dateSelected(today())
}

const leftArrowClicked = () => {
  setRange({
    start: moment(props.range.start).startOf('hour').subtract(12, 'hours'),
    end: moment(props.range.end).startOf('hour').subtract(12, 'hours'),
  })
}

const rightArrowClicked = () => {
  setRange({
    start: moment(props.range.start).startOf('hour').add(12, 'hours'),
    end: moment(props.range.end).startOf('hour').add(12, 'hours'),
  })
}

const dateSelected = (dateStr: string) => {
  setTimeout(() => {
    menu.value = false
  }, 250)

  setRange({
    start: moment(dateStr, 'YYYY-MM-DD').hour(6),
    end: moment(dateStr, 'YYYY-MM-DD').hour(18),
  })
}

const setRange = (range: Range) => {
  emit('rangechanged', range)
}
</script>

<style scoped>
.navigator {
  position: absolute;
  right: 16px;
  top: 24px;
  z-index: var(--elevation-schedule-view-navigator);
  background-color: var(--color-white);
  padding: var(--space-small);
  border-radius: var(--space-larger);
  box-shadow: var(--shadow-low);
}
</style>
